import React from 'react';
import { Box, Container, Divider, Link, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import BrandLockup from '../brand/BrandLockup';
import './PublicFooter.css';

interface PublicFooterProps {
  showAuthLinks?: boolean;
}

const PublicFooter: React.FC<PublicFooterProps> = ({ showAuthLinks = true }) => {
  const { t } = useLanguage();
  const email = t('landing.contactEmail');

  return (
    <Box component="footer" className="public-footer">
      <Container maxWidth="lg">
        <Box className="public-footer-main">
          <Box className="public-footer-brand">
            <Link component={RouterLink} to="/" aria-label="Veresiye" underline="none" className="public-footer-wordmark">
              <BrandLockup markSize={36} fontSize="1.35rem" gap={0.6} onDarkSurface />
            </Link>
            <Typography variant="body2">{t('landing.footerBrandLine')}</Typography>
          </Box>

          <Box className="public-footer-links">
            <Typography variant="overline">{t('landing.footerLinks')}</Typography>
            <Stack component="nav" direction="row" spacing={2} useFlexGap flexWrap="wrap" aria-label={t('landing.footerLinks')}>
              <Link component={RouterLink} to="/help">{t('nav.help')}</Link>
              <Link component={RouterLink} to="/brand">{t('landing.brandPage')}</Link>
              {showAuthLinks && (
                <>
                  <Link component={RouterLink} to="/login">{t('landing.footerLogin')}</Link>
                  <Link component={RouterLink} to="/register">{t('landing.footerRegister')}</Link>
                </>
              )}
            </Stack>
          </Box>

          <Box className="public-footer-contact">
            <Typography variant="overline">{t('landing.contactLabel')}</Typography>
            <Link href={`mailto:${email}`} underline="none" className="public-footer-email">{email}</Link>
          </Box>
        </Box>
        <Divider className="public-footer-divider" />
        <Typography variant="caption" className="public-footer-copyright">
          © {new Date().getFullYear()} Veresiye. {t('landing.rights')}
        </Typography>
      </Container>
    </Box>
  );
};

export default PublicFooter;
